// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBgaKReO26fX3_1pYtSrQAkqKNUPp5tE4g",
  authDomain: "zzeeh-productions-2006.firebaseapp.com",
  projectId: "zzeeh-productions-2006",
  storageBucket: "zzeeh-productions-2006.firebasestorage.app",
  messagingSenderId: "485439315400",
  appId: "1:485439315400:web:a50b910027d06634c3f4fd",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

// Initialize Analytics and get a reference to the service
// const analytics = getAnalytics(app);

// Initialize Cloud Firestore and get a reference to the service
// const db = getFirestore(app);

// const provider = new GoogleAuthProvider();

export { auth };
